import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchInvoices } from '../services/api';

export const getInvoices = createAsyncThunk('invoices/getInvoices', async () => {
    const response = await fetchInvoices();
    return response.data;
});

const invoiceSlice = createSlice({
    name: 'invoices',
    initialState: {
        invoices: [],  // Storing open calls here
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: {
        [getInvoices.pending]: (state) => {
            state.status = 'loading';
        },
        [getInvoices.fulfilled]: (state, action) => {
            state.invoices = action.payload.invoices;
            state.status = 'succeeded';
        },
        [getInvoices.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    },
});

export default invoiceSlice.reducer;